import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7cbfce9f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "correct" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bigtitle" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "line1" }, "思考")
], -1))
const _hoisted_3 = { class: "boxTail" }
const _hoisted_4 = { class: "leftright" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("p", null, " 辅舒良的主要成分是丙酸氟替卡松，属于二代糖皮质激素，有强效的抗炎活性，可以有效的清洗鼻腔、鼻窦及鼻甲，洗掉细菌、病毒等污染物，而且能在鼻腔内形成微生态保护薄，隔离细菌、病毒，防止感染。 ")
  ])
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "circle" }, [
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("div")
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "jiexi" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "daan" }),
  /*#__PURE__*/_createElementVNode("div", { class: "dadesc" })
], -1))
const _hoisted_8 = { class: "ip" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "paper" }, [
  /*#__PURE__*/_createElementVNode("span", null, "中华耳鼻咽喉头颈外科杂志2022 年2月第57卷第2期，106-129"),
  /*#__PURE__*/_createElementVNode("span", null, "编号PM-CN-FLX-23-00149，有效期至24 Apr 2028"),
  /*#__PURE__*/_createElementVNode("div", null, " 本材料并非广告，旨在向且仅向医疗保健专业人士提供科学信息。如果您不是医疗保健专业人士，请勿阅读或传播其中的内容。 ")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_van_image, {
            class: "rightImg",
            width: ".64rem",
            height: ".6133rem",
            src: require('../assets/duigou.png')
          }, null, 8, ["src"])
        ]),
        _hoisted_5
      ]),
      _hoisted_6,
      _hoisted_7
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_van_image, {
        class: "footBtn",
        onClick: $options.nexStep,
        width: "5.64rem",
        height: "1.3333rem",
        src: require('../assets/jxbtn.png')
      }, null, 8, ["onClick", "src"]),
      _createVNode(_component_van_image, {
        class: "finger",
        width: "1.28rem",
        height: "1.28rem",
        src: require('../assets/dong.gif')
      }, null, 8, ["src"])
    ]),
    _hoisted_9
  ], 64))
}